//
export default {
    //
    product: [
        {
            text: 'código proveedor',
            value: 'provider_product_code',
            input: {
                type: 'text-field',
            },
            width: '15%',
        },
        {
            text: 'código interno',
            value: 'internal_code',
            width: '15%',
        },
        {
            text: 'nombre',
            value: 'name',
        },
        {
            text: 'stock',
            value: 'stock',
            align: 'right',
            width: '15%',
        },
        {
            text: 'cantidad',
            value: 'quantity',
            align: 'right',
            input: {
                reverse: true,
                type: 'text-field',
            },
            width: '15%',
        },
    ],

    //
    order: [
        {
            text: '#',
            value: 'id',
            component: {
                custom: 'id',
                type: 'link',
                props: {
                    mapper: value => ({
                        name: 'purchase-order-update',
                        params: {
                            id: value,
                        },
                    }),
                    tooltip: 'Detalle orden de compra',
                },
            },
        },
        {
            text: 'n° factura',
            value: 'invoice_number',
        },
        {
            text: 'neto',
            value: 'net_subtotal',
            format: 'currency',
        },
        {
            text: 'iva',
            value: 'iva',
            format: 'currency',
        },
        {
            text: 'total',
            value: 'total',
            format: 'currency',
        },
        {
            text: 'estado',
            value: ({ pch_purchase_order_state }) =>
                pch_purchase_order_state.state || '',
            component: {
                type: 'chip',
                props: {
                    disabled: true,
                    label: true,
                    small: true,
                    textColor: 'black',
                },
            },
        },
        {
            text: 'fecha de creación',
            value: 'created_at',
            format: 'datetime',
        },
    ],
}
